export const getLastNote = (notes) => {
  const lastNote = notes?.sort((a, b) => {
    return new Date(b.createdAt) - new Date(a.createdAt);
  })?.[0];
  return lastNote;
};
